import Vue from 'vue'
import Router from 'vue-router'
import authMiddleware from './middlewares/auth'
import middlewarePipeline from './middlewares/pipeline'

Vue.use(Router)

const createRouter = () => new Router({
  routes: [
    {
      path: '/',
      name: 'admin.home',
      redirect: { name: 'admin.dashboard' },
      component: () => import('@/pages/Home'),
      children: [
        {
          path: '/dashboard',
          name: 'admin.dashboard',
          component: () => import('@/components/DashBoard')
        },
        {
          path: '/reports',
          name: 'admin.report',
          redirect: { name: 'admin.report.supplier_match' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/supplier_match',
              name: 'admin.report.supplier_match',
              component: () => import('@/components/Reports/Supplier/Match')
            },
            {
              path: '/buyer_requests',
              name: 'admin.report.buyer_requests',
              redirect: { name: 'admin.report.buyer_requests.search' },
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'search',
                  name: 'admin.report.buyer_requests.search',
                  component: () => import('@/components/Reports/Buyer/Requests')
                },
                {
                  path: 'edit/:request',
                  name: 'admin.report.buyer_requests.edit',
                  component: () => import('@/components/Reports/Buyer/RequestEdit')
                }
              ]
            }
          ]
        },
        {
          path: '/organizations',
          name: 'admin.organization',
          redirect: { name: 'admin.organization.search' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'search',
              name: 'admin.organization.search',
              component: () => import('@/components/Organization/Index')
            },
            {
              path: 'edit/:organization',
              name: 'admin.organization.edit',
              component: () => import('@/components/Organization/Edit')
            },
            {
              path: 'create',
              name: 'admin.organization.create',
              component: () => import('@/components/Organization/Create')
            },
            {
              path: 'massives',
              name: 'admin.user.massives',
              component: () => import('@/components/User/Massives')
            },
            {
              path: 'users/:organization',
              name: 'admin.user',
              redirect: { name: 'admin.user.search' },
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'search',
                  name: 'admin.user.search',
                  component: () => import('@/components/User/Index')
                },
                {
                  path: 'create',
                  name: 'admin.user.create',
                  component: () => import('@/components/User/Create')
                },
                {
                  path: 'massive',
                  name: 'admin.user.massive',
                  component: () => import('@/components/User/Massive')
                },
                {
                  path: 'edit/:user',
                  name: 'admin.user.edit',
                  component: () => import('@/components/User/Edit')
                }
              ]
            },
            {
              path: 'contacts/:organization',
              name: 'admin.contacts',
              redirect: { name: 'admin.contacts.search' },
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'search',
                  name: 'admin.contacts.search',
                  component: () => import('@/components/Contact/Index')
                }
                // {
                //   path: 'create',
                //   name: 'admin.user.create',
                //   component: () => import('@/components/User/Create')
                // },
                // {
                //   path: 'edit/:user',
                //   name: 'admin.user.edit',
                //   component: () => import('@/components/User/Edit')
                // }
              ]
            },
            {
              path: 'catalogs/:organization',
              name: 'admin.catalog',
              redirect: { name: 'admin.catalog.search' },
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'search',
                  name: 'admin.catalog.search',
                  component: () => import('@/components/Catalog/Index')
                },
                {
                  path: 'create',
                  name: 'admin.catalog.create',
                  component: () => import('@/components/Catalog/Create')
                },
                {
                  path: 'edit/:catalog',
                  name: 'admin.catalog.edit',
                  component: () => import('@/components/Catalog/Edit')
                },
                {
                  path: 'upload/:catalog',
                  name: 'admin.catalog.upload',
                  component: () => import('@/components/Catalog/Upload')
                }
              ]
            },
            {
              path: 'users/:organization',
              name: 'admin.organization.users',
              component: () => import('@/components/Catalog/Index')
            }
          ]
        },
        {
          path: '/org-proveedores',
          name: 'proveedores.admin.organization',
          redirect: { name: 'proveedores.admin.organization.search' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'search',
              name: 'proveedores.admin.organization.search',
              component: () => import('@/components/Organization/Index')
            },
            {
              path: 'edit/:organization',
              name: 'proveedores.admin.organization.edit',
              component: () => import('@/components/Organization/Edit')
            },
            {
              path: 'create',
              name: 'proveedores.admin.organization.create',
              component: () => import('@/components/Organization/Create')
            },
            {
              path: 'massives',
              name: 'proveedores.admin.user.massives',
              component: () => import('@/components/User/Massives')
            },
            {
              path: 'users/:organization',
              name: 'proveedores.admin.user',
              redirect: { name: 'proveedores.admin.user.search' },
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'search',
                  name: 'proveedores.admin.user.search',
                  component: () => import('@/components/User/Index')
                },
                {
                  path: 'create',
                  name: 'proveedores.admin.user.create',
                  component: () => import('@/components/User/Create')
                },
                {
                  path: 'massive',
                  name: 'proveedores.admin.user.massive',
                  component: () => import('@/components/User/Massive')
                },
                {
                  path: 'edit/:user',
                  name: 'proveedores.admin.user.edit',
                  component: () => import('@/components/User/Edit')
                }
              ]
            },
            {
              path: 'contacts/:organization',
              name: 'proveedores.admin.contacts',
              redirect: { name: 'proveedores.admin.contacts.search' },
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'search',
                  name: 'proveedores.admin.contacts.search',
                  component: () => import('@/components/Contact/Index')
                }
              ]
            },
            {
              path: 'catalogs/:organization',
              name: 'proveedores.admin.catalog',
              redirect: { name: 'proveedores.admin.catalog.search' },
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'search',
                  name: 'proveedores.admin.catalog.search',
                  component: () => import('@/components/Catalog/Index')
                },
                {
                  path: 'create',
                  name: 'proveedores.admin.catalog.create',
                  component: () => import('@/components/Catalog/Create')
                },
                {
                  path: 'edit/:catalog',
                  name: 'proveedores.admin.catalog.edit',
                  component: () => import('@/components/Catalog/Edit')
                },
                {
                  path: 'upload/:catalog',
                  name: 'proveedores.admin.catalog.upload',
                  component: () => import('@/components/Catalog/Upload')
                },
                {
                  path: 'contract/:catalog',
                  name: 'proveedores.admin.catalog.contract_data',
                  component: () => import('@/components/Catalog/ContractData')
                }
              ]
            },
            {
              path: 'users/:organization',
              name: 'proveedores.admin.organization.users',
              component: () => import('@/components/Catalog/Index')
            }
          ]
        },
        {
          path: '/banners',
          name: 'admin.banner',
          redirect: { name: 'admin.banner.list' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'admin.banner.list',
              component: () => import('@/components/Banners/Index')
            },
            {
              path: 'create',
              name: 'admin.banner.create',
              component: () => import('@/components/Banners/Create')
            },
            {
              path: 'edit/:banner',
              name: 'admin.banner.edit',
              component: () => import('@/components/Banners/Edit')
            }
          ]
        },
        {
          path: '/searchs',
          name: 'admin.search',
          redirect: { name: 'admin.search.list' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'admin.search.list',
              component: () => import('@/components/Searchs/Index')
            },
            {
              path: 'create',
              name: 'admin.search.create',
              component: () => import('@/components/Searchs/Create')
            }
          ]
        },
        {
          path: '/montos-cotizaciones',
          name: 'admin.montos-cotizaciones',
          redirect: { name: 'admin.manage.montos-cotizaciones' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: 'admin.manage.montos-cotizaciones',
              component: () => import('@/components/Montos_Cotizaciones/ManageMontosCotizaciones')
            }
          ]
        },
        {
          path: '/pay4supply',
          name: 'admin.pay4supply',
          redirect: { name: 'admin.pay4supply.terms-conditions' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: 'admin.pay4supply.terms-conditions',
              component: () => import('@/components/Pay4supply/Index')
            }
          ]
        },
        {
          path: '/terms-and-conditions',
          name: 'admin.terms-conditions',
          redirect: { name: 'admin.manage.terms-conditions' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: 'admin.manage.terms-conditions',
              component: () => import('@/components/Terms/Index')
            }
          ]
        },
        {
          path: '/news-marketplace',
          name: 'admin.news-marketplace',
          redirect: { name: 'admin.manage.news' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: 'admin.manage.news',
              component: () => import('@/components/NewsMarketplace/Index')
            }
          ]
        },
        {
          path: '/admin-workflows',
          name: 'admin.workflows',
          redirect: { name: 'admin.workflows.clients' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'manage',
              name: 'admin.workflows.clients',
              component: () => import('@/components/Workflows/Index')
            }
          ]
        },
        {
          path: '/cat4mro',
          name: 'cat4mro.admin.catalog',
          redirect: { name: 'cat4mro.admin.index' },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'cat4mro.admin.index',
              component: () => import('@/components/Cat4mro/Index')
            },
            {
              path: 'upload/:catalog',
              name: 'cat4mro.admin.catalog.upload',
              component: () => import('@/components/Catalog/Upload')
            },
            {
              path: 'edit/:catalog',
              name: 'cat4mro.admin.catalog.edit',
              component: () => import('@/components/Catalog/Edit')
            },
            {
              path: 'contract/:catalog',
              name: 'cat4mro.admin.catalog.contract_data',
              component: () => import('@/components/Catalog/ContractData')
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      component: () => import('@/pages/Login'),
      meta: {
        layout: 'blank',
        allowAnonymous: true
      }
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('@/pages/Error'),
      meta: {
        layout: 'blank',
        allowAnonymous: true
      }
    }
  ]
})

const router = createRouter()

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.allowAnonymous)) {
    return next()
  }

  const middleware = to.meta.middleware || []
  const context = {
    to,
    from,
    next
  }

  return authMiddleware({
    ...context,
    next: middlewarePipeline(context, middleware, 0)
  })
})

export function extendRouter (newRoutes) {
  router.addRoutes(newRoutes)
}

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

// router.replace({ path: '/dashboard', redirect: '/dashboard' })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js